import { sanitizeText } from "@/js/helperV2"
import { sanitizeDOMString } from "@/utils/helper"

export const getTranslations = (t, authorData = {}) => {
  return {
    home: t("kf.orderStatus.label.home"),
    orderStatus: t("kf.orderStatus.label.orderStatus"),
    orderStatusDesc: t("kf.orderStatus.label.orderStatusDesc"),
    orderNo: t("kf.orderStatus.label.orderNo"),
    email: t("kf.orderStatus.label.email"),
    wheresOrderNo: t("kf.orderStatus.label.wheresOrderNo"),
    tooltipMssg: t("kf.orderStatus.label.tooltipMssg"),
    findMyOrder: t("kf.orderStatus.label.findMyOrder"),
    callSupport: t("kf.orderStatus.label.callSupport"),
    emptyOrderNo: t("kf.orderStatus.label.emptyOrderNo"),
    validOrderNo: t("kf.orderStatus.label.validOrderNo"),
    emptyEmail: t("kf.orderStatus.label.emptyEmail"),
    validEmail: t("kf.orderStatus.label.validEmail"),
    cantFindOrder: t("kf.orderStatus.label.cantFindOrder"),
    genError: t("kf.error.message.genericError"),
    orderWarningDesc1: t("kf.orderStatus.message.orderWarningDesc1"),
    orderWarningDesc2: t("kf.orderStatus.message.orderWarningDesc2"),
    orderWarningTitle: t("kf.orderStatus.label.orderWarningTitle"),
    orderWarningDesc1: t("kf.orderStatus.message.orderWarningDesc1"),
    orderWarningDesc2: t("kf.orderStatus.message.orderWarningDesc2"),
    orderWarningContinueCta: t("kf.orderStatus.button.orderWarningContinueCta"),
    home: t("kf.global.label.home"),
    order: t("kf.orderHistory.label.order"),
    orderDetails: t("kf.orderDetails.label.orderDetails"),
    orderPlacedOn: t("kf.orderDetails.label.orderPlacedOn"),
    customerInfo: t("kf.orderDetails.label.customerInfo"),
    contactInfo: t("kf.orderDetails.label.contactInfo"),
    shippingAddress: t("kf.orderDetails.label.shippingAddress"),
    paymentInfo: t("kf.orderDetails.label.paymentInfo"),
    billingAddress: t("kf.orderDetails.label.billingAddress"),
    endingIn: t("kf.orderDetails.label.endingIn"),
    expiry: t("kf.orderDetails.label.expiry"),
    print: t("kf.orderDetails.label.print"),
    downloadSpecs: t("kf.orderDetails.label.downloadSpecs"),
    needHelp: t("kf.orderDetails.label.needHelp"),
    supportDesc1: t("kf.orderDetails.label.supportDesc1"),
    returnPolicy: t("kf.orderDetails.label.returnPolicy"),
    or: t("kf.orderDetails.label.or"),
    productWarranty: t("kf.orderDetails.label.productWarranty"),
    supportDesc2: t("kf.orderDetails.label.supportDesc2"),
    callSupport: t("kf.orderDetails.label.callSupport"),
    orderSummary: t("kf.orderDetails.label.orderSummary"),
    subTotal: t("kf.orderDetails.label.subTotal"),
    totalPromotions: t("kf.orderDetails.label.totalPromotions"),
    shipping: t("kf.orderDetails.label.shipping"),
    taxes: t("kf.orderDetails.label.taxes"),
    orderTotal: t("kf.orderDetails.label.orderTotal"),
    orderStatus: t("kf.orderDetails.label.orderStatus"),
    orderNumber: t("kf.orderDetails.label.orderNumber"),
    qty: t("kf.cart.label.qty"),
    quantity: t("kf.checkout.label.quantity"),
    unitPrice: t("kf.cart.label.unitPrice"),
    total: t("kf.cart.label.total"),
    colorFinish: t("kf.cart.label.colorFinish"),
    parcelShipping: t("kf.orderDetails.label.parcelShipping"),
    freightShipping: t("kf.orderDetails.label.freightShipping"),
    parcelShippingDesc: days =>
      t("kf.orderDetails.label.parcelShippingDesc", { days }),
    freightShippingDesc: days =>
      t("kf.orderDetails.label.freightShippingDesc", { days }),
    registerProducts: t("kf.orderDetails.label.registerProducts"),
    createReturn: t("kf.orderDetails.label.createReturn"),
    tracking: t("kf.orderDetails.label.tracking"),
    allItemsCancelled: t("kf.orderDetails.label.allItemsCancelled"),
    fewItemsCancelled: t("kf.orderDetails.label.fewItemsCancelled"),
    note: t("kf.cart.label.note"),
    comboSkuMssg: t("kf.cart.label.comboSkuMssg"),
    eDelivery: t("kf.cart.label.eDelivery"),
    eDeliveryDesc: days => t("kf.cart.label.eDeliveryDesc", { days }),
    eDeliveryNote: t("kf.orderDetails.label.eDeliveryNote"),
    eDeliveryMsg: t("kf.orderDetails.label.eDeliveryMsg"),
    email: t("kf.orderConf.label.email"),
    viewPartsDiagram: t("kf.orderDetails.label.viewPartsDiagram"),
    noOrderFound: t("kf.orderConf.label.noOrderFound"),
    printAria: t("kf.orderDetails.label.printAria"),
    comboSkuDelivery: t("kf.orderDetails.label.comboSkuDelivery"),
    itemOf: (index, count) =>
      t("kf.orderDetails.label.itemOf", { index, count }),
    parcelTooltip: t("kf.orderDetails.label.parcelTooltip"),
    parcelShippingAriaLabel: t("kf.checkout.label.parcelShippingAriaLabel"),
    freightTooltip: t("kf.orderDetails.label.freightTooltip"),
    eDeliveryTooltip: t("kf.orderDetails.label.eDeliveryTooltip"),
    discountPercentage: t("kf.checkout.label.discountPercentage"),
    off: t("kf.cart.label.off"),
    ariaLabel: {
      partsDiagram: product =>
        t("kf.myProducts.aria.label.partsDiagram", { product }),
      currentPage: t("kf.pdp.label.aria.currentPage"),
      page: t("kf.pdp.label.aria.page"),
    },
    openNewTabText: t("kf.share.label.openNewTabText"),
    backOrderMssg: days => t("kf.cart.label.backOrderMssg", { days }),
    orders: t("kf.orderHistory.label.orders"),
    cancelled: t("kf.orderDetails.label.cancelled"),
    hi: t("kf.account.label.hi"),
    signOut: t("kf.account.label.signOut"),
    myAccount: t("kf.account.label.myAccount"),
    favorites: t("kf.account.label.favorites"),
    accountSettings: t("kf.account.label.accountSettings"),
    orders: t("kf.account.label.orders"),
    myProducts: t("kf.account.label.myProducts"),
    myServices: t("kf.account.label.myServices"),
    ariaSignOut: t("kf.loggedin.button.aria.signOut"),
    menuItems: pageName =>
      t("kf.account.aria.menuItems", {
        pageName,
      }),
    order: t("kf.orderHistory.label.order"),
    orders: t("kf.orderHistory.label.orders"),
    openOrders: t("kf.orderHistory.label.openOrders"),
    pastOrders: t("kf.orderHistory.label.pastOrders"),
    customerServices: t("kf.orderHistory.label.customerServices"),
    orderPlacedOnHistory: t("kf.orderHistory.label.orderPlacedOn"),
    items: t("kf.orderHistory.label.items"),
    orderTotal: t("kf.orderHistory.label.orderTotal"),
    orderStatus: t("kf.orderHistory.label.orderStatus"),
    viewOrder: t("kf.orderHistory.label.viewOrder"),
    continueShopping: t("kf.orderHistory.label.continueShopping"),
    noOpenOrders: t("kf.orderHistory.label.noOpenOrders"),
    loading: t("kf.search.label.loading"),
    orderCreatedOn: showOrdersFromLabel =>
      showOrdersFromLabel
        ? sanitizeDOMString(showOrdersFromLabel)
        : t("kf.orderHistory.label.orderCreatedOn"),
    thankYouForOrder: t("kf.orderConf.label.thankYouForOrder"),
    freeShipping: t("kf.label.freeShipping"),
    orderConfMessage: t("kf.orderConf.label.orderConfMessage"),
    emailMessage: t("kf.orderConf.label.emailMessage"),
    orderConfirmation: t("kf.orderConf.label.orderConfirmation"),
    orderConfirmationNumber: t("kf.orderConf.label.orderConfirmationNumber"),
    email: t("kf.orderConf.label.email"),
    customerInfo: t("kf.orderDetails.label.customerInfo"),
    contactInfo: t("kf.orderDetails.label.contactInfo"),
    shippingAddress: t("kf.orderDetails.label.shippingAddress"),
    paymentInfo: t("kf.orderDetails.label.paymentInfo"),
    billingAddress: t("kf.orderDetails.label.billingAddress"),
    endingIn: t("kf.orderDetails.label.endingIn"),
    expiry: t("kf.orderDetails.label.expiry"),
    print: t("kf.orderDetails.label.print"),
    downloadSpecs: t("kf.orderDetails.label.downloadSpecs"),
    needHelp: t("kf.orderDetails.label.needHelp"),
    supportDesc: t("kf.orderDetails.label.supportDesc"),
    supportDesc1: t("kf.orderDetails.label.supportDesc1"),
    returnPolicy: t("kf.orderDetails.label.returnPolicy"),
    or: t("kf.orderDetails.label.or"),
    registerProducts: t("kf.orderDetails.label.registerProducts"),
    productWarranty: t("kf.orderDetails.label.productWarranty"),
    supportDesc2: t("kf.orderDetails.label.supportDesc2"),
    callSupport: t("kf.orderDetails.label.callSupport"),
    orderSummary: t("kf.orderDetails.label.orderSummary"),
    subTotal: t("kf.orderDetails.label.subTotal"),
    totalPromotions: t("kf.orderDetails.label.totalPromotions"),
    shipping: t("kf.orderDetails.label.shipping"),
    taxes: t("kf.orderDetails.label.taxes"),
    orderTotal: t("kf.orderDetails.label.orderTotal"),
    orderStatus: t("kf.orderDetails.label.orderStatus"),
    orderNumber: t("kf.orderDetails.label.orderNumber"),
    qty: t("kf.cart.label.qty"),
    quantity: t("kf.checkout.label.quantity"),
    unitPrice: t("kf.cart.label.unitPrice"),
    total: t("kf.cart.label.total"),
    colorFinish: t("kf.cart.label.colorFinish"),
    parcelShipping: t("kf.orderDetails.label.parcelShipping"),
    freightShipping: t("kf.orderDetails.label.freightShipping"),
    parcelShippingDesc: days =>
      authorData?.parcelMessage
        ? sanitizeText(authorData.parcelMessage.replace("{{days}}", days))
        : t("kf.orderDetails.label.parcelShippingDesc", { days }),
    freightShippingDesc: days =>
      authorData?.freightMessage
        ? sanitizeText(authorData.freightMessage.replace("{{days}}", days))
        : t("kf.orderDetails.label.freightShippingDesc", { days }),
    allItemsCancelled: t("kf.orderDetails.label.allItemsCancelled"),
    fewItemsCancelled: t("kf.orderDetails.label.fewItemsCancelled"),
    note: t("kf.cart.label.note"),
    comboSkuMssg: t("kf.cart.label.comboSkuMssg"),
    eDelivery: t("kf.cart.label.eDelivery"),
    eDeliveryDesc: days =>
      authorData?.eDeliveryMessage
        ? sanitizeText(authorData.eDeliveryMessage.replace("{{days}}", days))
        : t("kf.cart.label.eDeliveryDesc", { days }),
    eDeliveryNote: t("kf.orderDetails.label.eDeliveryNote"),
    eDeliveryMsg: t("kf.orderDetails.label.eDeliveryMsg"),
    viewPartsDiagram: t("kf.orderDetails.label.viewPartsDiagram"),
    printAria: t("kf.orderDetails.label.printAria"),
    comboSkuDelivery: t("kf.orderDetails.label.comboSkuDelivery"),
    parcelShippingAriaLabel: t("kf.checkout.label.parcelShippingAriaLabel"),
    itemOf: (index, count) =>
      t("kf.orderDetails.label.itemOf", { index, count }),
    parcelTooltip: t("kf.orderDetails.label.parcelTooltip"),
    freightTooltip: t("kf.orderDetails.label.freightTooltip"),
    eDeliveryTooltip: t("kf.orderDetails.label.eDeliveryTooltip"),
    discountPercentage: t("kf.checkout.label.discountPercentage"),
    off: t("kf.cart.label.off"),
    openNewTabText: t("kf.share.label.openNewTabText"),
    backOrderMssg: days => t("kf.cart.label.backOrderMssg", { days }),
    cancelled: t("kf.orderDetails.label.cancelled"),
    childOrderStatus: t("kf.orderDetails.label.childOrderStatus"),
    productDiscounts: t("kf.cart.label.productDiscounts"),
    shipmentOf: (number, total) =>
      t("kf.orderDetails.label.shipmentOf", { number, total }),
    homeowner: t("kf.auth.label.homeOwner"),
    professional: t("kf.auth.label.professional"),
    viewOrderDetails: t("kf.orderHistory.label.viewOrder"),
    createPassword: t("kf.account.label.createPassword"),
    password: t("kf.account.label.password"),
    passwordRequirements: t("kf.auth.label.passwordRequirements"),
    show: t("kf.auth.label.show"),
    hide: t("kf.auth.label.hide"),
    characterCount: t("kf.auth.label.characterCount"),
    uppercaseLetter: t("kf.auth.label.uppercaseLetter"),
    lowercaseLetter: t("kf.auth.label.lowercaseLetter"),
    symbolValidation: t("kf.auth.label.symbolValidation"),
    numberValidation: t("kf.auth.label.numberValidation"),
    pwMustInclude: t("kf.auth.label.pwMustInclude"),
    accountType: t("kf.account.label.accountType"),
    passwordError: t("kf.auth.error.passwordError"),
    passwordProvideError: t("kf.auth.label.provide.pwdError"),
    accountCreationWelcomeAria: t("kf.auth.label.welcomeAria"),
    backToTop: t("kf.favorite.label.backToTop"),
    view: "View",
    all: "All",
    loadMore: "Load More",
    items: t("kf.plp.items"),
    yourKohlerAccount: t("kf.auth.label.yourKohlerAccount"),
    signIn: t("Sign In"),
    createAccount: t("Create Account"),
    checkOrder: t("kf.orderStatus.label.checkOrder"),
    orderID: t("kf.orderStatus.label.orderID"),
    noResult: t("kf.orderStatus.label.noResult"),
  }
}
